import React, { useState, useEffect } from 'react';
import { challengeService } from '../services/api';

export default function Gamification() {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadChallenges();
  }, []);

  const loadChallenges = async () => {
    try {
      const response = await challengeService.getChallenges();
      setChallenges(response.data);
      setError(null);
    } catch (err) {
      setError('Error al cargar los desafíos');
      console.error('Error loading challenges:', err);
    } finally {
      setLoading(false);
    }
  };

  async function handleComplete(id) {
    try {
      await challengeService.completeChallenge(id);
      // Recargar los desafíos para obtener el estado actualizado
      loadChallenges();
      alert('¡Desafío completado! Se te asignó la insignia.');
    } catch (err) {
      console.error('Error completing challenge:', err);
      alert('Error al completar el desafío. Por favor, intenta de nuevo.');
    }
  }

  if (loading) return <div className="text-center py-12">Cargando desafíos...</div>;
  if (error) return <div className="text-center py-12 text-red-600">{error}</div>;

  return (
    <section className='max-w-6xl mx-auto px-4 py-12'>
      <h3 className='text-lg font-semibold mb-3'>Desafíos ciudadanos y badges</h3>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
        {challenges.map(c => (
          <div key={c.id} className='border rounded p-3 text-center'>
            <div className='font-semibold'>{c.title}</div>
            <div className='text-sm text-gray-600 mt-2'>{c.reward}</div>
            <div className='mt-3'>
              {authService.isAuthenticated() ? (
                <button 
                  disabled={c.completedBy?.includes(localStorage.getItem('userId'))} 
                  onClick={() => handleComplete(c.id)} 
                  className={`px-3 py-1 border rounded text-sm ${
                    c.completedBy?.includes(localStorage.getItem('userId'))
                      ? 'bg-green-100 text-green-800'
                      : 'bg-white hover:bg-gray-50'
                  }`}
                >
                  {c.completedBy?.includes(localStorage.getItem('userId')) 
                    ? 'Completado' 
                    : 'Marcar como completado'}
                </button>
              ) : (
                <Link 
                  to="/login" 
                  className="px-3 py-1 border rounded text-sm bg-gray-50 hover:bg-gray-100 text-gray-700"
                >
                  Iniciar sesión para participar
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
      {challenges.length === 0 && (
        <div className='text-center text-gray-500 mt-4'>
          No hay desafíos disponibles en este momento.
        </div>
      )}
    </section>
  );
}
